/** Símbolos y helpers — tablero seguimiento anual por auxiliar. */

export const TRACKING_CELL_SYMBOLS = {
  closed: { symbol: "✅", label: "Cerrado", className: "text-emerald-700" },
  closed_with_evidence: { symbol: "🔒", label: "Cerrado con evidencia", className: "text-emerald-800" },
  not_applicable: { symbol: "—", label: "No aplica", className: "text-slate-400" },
  in_progress: { symbol: "⏳", label: "En proceso", className: "text-blue-700" },
  due_soon: { symbol: "⚠️", label: "Por vencer", className: "text-amber-700" },
  pending: { symbol: "❌", label: "Pendiente", className: "text-rose-700" },
  overdue: { symbol: "❌", label: "Vencido", className: "text-rose-900 font-bold" },
  empty: { symbol: "○", label: "Sin instancias", className: "text-slate-300" },
};

export function trackingCellDisplay(status, { projected = false } = {}) {
  const base = TRACKING_CELL_SYMBOLS[status] || TRACKING_CELL_SYMBOLS.pending;
  if (!projected) return base;
  return {
    ...base,
    label: `${base.label} (proyectado — sin vencimientos generados)`,
    className: `${base.className} border border-dashed border-rose-300/80 bg-rose-50/40`,
  };
}

export const MONTH_SHORT = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

export function monthLabelFromKey(periodKey) {
  const parts = String(periodKey || "").split("-");
  if (parts.length < 2) return periodKey || "—";
  const m = parseInt(parts[1], 10);
  return MONTH_SHORT[m - 1] || parts[1];
}

export function currentTrackingYear() {
  return new Date().getFullYear();
}

/** True si la instancia cuenta como cerrada en la matriz de seguimiento. */
export function isTrackingInstanceClosed(row) {
  const cell = String(row?.cell_status || "").toLowerCase();
  if (cell === "closed" || cell === "closed_with_evidence" || cell === "not_applicable") {
    return true;
  }
  const status = String(row?.status || "").toLowerCase();
  if (status === "not_applicable_this_period" || status === "no_aplico_este_mes") return true;
  if (status === "cancelled") return true;
  if (status !== "done" && status !== "completada") return false;
  const filingType = row?.filing_type;
  const declaredAt = row?.declared_at;
  if (!filingType || !declaredAt) return false;
  if (row?.complementaria_pending) return false;
  if (row?.tax_paid === false) return false;
  return true;
}
